import { createSlice } from "@reduxjs/toolkit";
import { toGetBanners } from "../actions/HeroSection.actions";

const initialState = {
  Banners: {
    list: [],
    status: "",
  } as any,
  loading: false,
  error: null as unknown | null,
};
export const HeroSectionSlice = createSlice({
  name: "heroSection",
  initialState: initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder.addCase(toGetBanners.pending, (state) => {
      state.Banners = { list: [], status: "idle" };
    });
    builder.addCase(toGetBanners.fulfilled, (state, action) => {
      state.Banners = { list: action.payload.data, status: "succedded" };
    });
    builder.addCase(toGetBanners.rejected, (state, action) => {
      state.Banners = { list: [], status: "rejected" };
      state.error = action.payload;
    });
  },
});

export default HeroSectionSlice.reducer;
